import { render } from "./SidebarMenuLinkDirect.vue?vue&type=template&id=3ab870ad"
import script from "./SidebarMenuLinkDirect.vue?vue&type=script&lang=js"
export * from "./SidebarMenuLinkDirect.vue?vue&type=script&lang=js"

import "./SidebarMenuLinkDirect.vue?vue&type=style&index=0&id=3ab870ad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__